<script>
  import ReportInfo from 'src/pc/components/ReportInfo'
  export default {
    extends: ReportInfo,
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>

.live_reporting .summary {
  display: block !important;
  position: relative !important;
  z-index: 1 !important;
}
.live_reporting .summary ul {
  display: block !important;
  background: #003501 !important;
  padding: 20px 40px 20px 20px !important;
}
.live_reporting .summary li {
  font-size: 1.15em !important;
  font-weight: 600 !important;
  color: #fff !important;
  line-height: 1.2em !important;
  padding: 6px 0 !important;
  vertical-align: baseline !important ;
}
.live_reporting .summary li.entry em {
  font-style: normal !important;
  font-weight: 900 !important;
  vertical-align: baseline !important;
}
.live_reporting .summary li.entry em b {
  display: inline-block !important;
  font-size: 1.8em !important;
  font-weight: 700 !important;
  color: #00ff64 !important;
  vertical-align: baseline !important;
}
.live_reporting .summary li.level {
  font-size: 0.85em !important;
  font-weight: 400 !important;
  opacity: 0.75 !important;
}
.live_reporting .summary:after {
  content: "" !important;
  position: absolute !important;
  right: 6.5% !important;
  top: 50% !important;
  transform: translate(0, -50%) !important;
  display: inline-block !important;
  width: 16px !important;
  height: 14px !important;
  background: url(/statics/img/a_arrow_v.png) no-repeat !important;
  background-size: contain !important;
  /*filter: brightness(0);*/
  transition: .15s !important;
}
.live_reporting .summary.show:after {
  transform: translate(0, -50%) rotate(180deg) !important;
}
.live_reporting .report_info.show {
  display: none !important;
}
.live_reporting .report_info {
  display: block !important;
  position: relative !important;
}
.live_reporting .report_info .title {
  display: none !important;
}
.live_reporting .report_info {
  background: #008c03 !important;
  margin-bottom: 20px !important;
  z-index: 2 !important;
  margin-top: 0 !important;
}
.live_reporting .report_info ul {
  border-bottom: 1px solid rgba(0,0,0,0.25) !important;
}
.live_reporting .report_info .cont {
  background: none !important;
  color: #fff !important;
}
.live_reporting .report_info .cont li:nth-child(2) {
  border-left: 1px solid rgba(0,0,0,0.15) !important;
}
.live_reporting .report_info ul li {
  padding: 15px 0 !important;
  line-height: 1.4em !important;
  font-weight: 500 !important;
  color: rgba(255,255,255,0.65)!important;
}
</style>
